import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import { deleteQuestion, updateQuestion } from "../store/features/CreateSurveySlice";
import { deleteSurveyQuestion, updateSurveyQuestion } from "../Firebase/utils";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import CustomDropdown from "./CustomDropdown";
import { Question } from "../types";
import DropDownSelectionForm from "./DropDownSelectionForm";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";
import QuestionResponseContainer from "./QuestionResponseContainer";

interface DropdownSelectionOptionsResponseDisplayProps {
    question: Question,
    questionText: string;
    options: string[];
    value?: string;
    setValue?: (value: string) => void;
}

export default (props: DropdownSelectionOptionsResponseDisplayProps) => {

    const { question, questionText, options } = props;
    const [ selectedOption, setSelectedOption ] = useState<string>('');
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);

    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:selectedOption}))
    }, [selectedOption]);

    return (
        <QuestionResponseContainer question={question}>
            <div className="flex flex-col w-full gap-4">
                <CustomDropdown label="Select One" options={options} selectedOption={selectedOption} setSelectedOption={setSelectedOption}/>
            </div>
        </QuestionResponseContainer>
    )
}